import z from "zod";
import { dayjs } from "../dayjs/dayjs.js";
export const ISO_DATE_FORMAT = "YYYY-MM-DD";
export const IsoDateSchema = z.iso
    .date()
    .brand();
export const DateRangeSchema = z
    .object({
    from: IsoDateSchema,
    to: IsoDateSchema,
})
    // Zod runs an object's refinements even when its fields failed, so this must
    // be total for any pair of strings. An ISO date is fixed-width and
    // zero-padded, which makes comparing dates as text the same as comparing the
    // calendar.
    .refine((range) => range.from <= range.to, {
    message: "to must not be before from",
    path: ["to"],
})
    .brand();
/**
 * Every date in the range, earliest first.
 *
 * Walked in UTC, where no day is ever 23 or 25 hours long, so a clock change
 * can neither drop a date nor produce one twice.
 */
export function datesInRange(range) {
    const dates = [];
    const last = dayjs.utc(range.to, ISO_DATE_FORMAT);
    for (let date = dayjs.utc(range.from, ISO_DATE_FORMAT); !date.isAfter(last, "day"); date = date.add(1, "day")) {
        dates.push(IsoDateSchema.parse(date.format(ISO_DATE_FORMAT)));
    }
    return dates;
}
//# sourceMappingURL=date.js.map